import { StyleSheet } from 'aphrodite';
import { borderColor, brandPrimaryHoverTint, hotPink, nameCircles, white } from '../../styles/colors';
import { CssSelectors } from '../../styles/styles';

const borderStyle = `1px solid ${borderColor}`;

export const dataGridStyles = StyleSheet.create({
	badge: {
		background: '#FCE0F3',
		color: hotPink,
	},
	tableDataCellBorderless: {
		padding: '16px 10px 16px 10px',
	},
	tableDataCell: {
		borderTop: borderStyle,
		padding: '16px 10px 16px 10px',
	},
	tableDataCellSticky: {
		position: 'sticky',
		top: 0,
		left: 0,
		background: white,
		whiteSpace: 'nowrap',
		':before': {
			content: '""',
			position: 'absolute',
			top: 0,
			right: 0,
			width: 1,
			height: '100%',
			background: nameCircles,
			boxShadow: '0 0 6px rgba(0,0,0,0.25)',
		},
		':after': {
			content: '""',
			position: 'absolute',
			top: 0,
			right: 0,
			width: 1,
			height: '100%',
			background: nameCircles,
			boxShadow: '0 0 6px rgba(0,0,0,0.25)',
		},
	},
	table: {
		alignItems: 'stretch',
		border: 'none',
		borderRadius: 8,
		boxShadow: '0px 0px 6px rgba(139, 139, 139, 0.1)',
		boxSizing: 'border-box',
		paddingTop: 20,
		paddingBottom: 20,
		width: '100%',
		borderSpacing: 0,
	},
	tableHeader: {
		background: '#fff',
		whiteSpace: 'nowrap',
	},
	tableHeaderCell: {
		color: '#AAAAAA',
		fontSize: 11,
		letterSpacing: '1.1px',
		textTransform: 'uppercase',
		padding: 10,
	},
	tableHeaderCellSticky: {
		position: 'sticky',
		left: 0,
		zIndex: 10,
		backgroundColor: brandPrimaryHoverTint,
		boxShadow: `1px 0 4px rgba(0, 0, 0, 0.1)`,
	},
	tableBodyCellSticky: {
		position: 'sticky',
		left: 0,
		zIndex: 10,
		backgroundColor: brandPrimaryHoverTint,
		boxShadow: `1px 0 4px rgba(0, 0, 0, 0.1)`,
	},
	tableDataCellCentered: {
		textAlign: 'center',
		verticalAlign: 'middle',
	},
	tableHeaderCellCentered: {
		textAlign: 'center',
		verticalAlign: 'middle',
	},
	stackedCell: {
		display: 'flex',
		flexDirection: 'column',
	},
	fullHeightTable: {
		height: '100%',
	},
	tableHeaderRow: {
		backgroundColor: brandPrimaryHoverTint,
		...CssSelectors.allChildren(
			{
				borderTopLeftRadius: 8,
			},
			':first-child'
		),
		...CssSelectors.allChildren(
			{
				borderTopRightRadius: 8,
			},
			':last-child'
		),
	},
	tableRow: {
		...CssSelectors.allChildren(
			{
				paddingLeft: 20,
			},
			':first-child'
		),
		...CssSelectors.allChildren(
			{
				paddingRight: 20,
			},
			':last-child'
		),
	},
	tableRowSticky: {
		position: 'sticky',
		top: 0,
		background: brandPrimaryHoverTint,
		boxShadow: '0 0 6px rgba(0,0,0,0.25)',
	},
});
